module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('label', {
    staticClass: "text-white mb-4 flex items-start gap-x-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmData),
      expression: "confirmData"
    }],
    attrs: {
      "type": "checkbox",
      "name": "confirm_data",
      "id": "confirm_data"
    },
    domProps: {
      "checked": Array.isArray(_vm.confirmData) ? _vm._i(_vm.confirmData, null) > -1 : (_vm.confirmData)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.confirmData,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.confirmData = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.confirmData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.confirmData = $$c
        }
      }
    }
  }), _vm._v("\n      I confirm that the data on the card I am about to submit matches my registration data.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.confirmData) ? _c('a', {
    staticClass: "button is-success",
    on: {
      "click": _vm.sendRequest
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("deposit").tUpper()) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-260ca138"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/deposit-methods/mulix-methods/mulix-visa.vue
// module id = 734
// module chunks = 0